<template>
  <div id="hyppo-card-list">
    <b-list-group v-if="items">
      <b-list-group-item
        v-for="(card, index) in items" :key="card.card_id"
        class="justify-content-between align-items-center">
        <div class="row">
          <!-- <div class="col-sm-3">
            {{card.card_id}}
          </div> -->
          <div class="col-sm-2">
            <b-badge v-if="card.card_index!=-1" pill variant="light">N°{{card.card_index}} </b-badge>
            <b-badge v-else pill variant="light">TMP </b-badge>
          </div>
          <div class="col-sm-3">
            <b-badge
              pill
              variant="dark"
              v-b-tooltip.hover.bottom="'Temps d\'attente de la carte'"
              v-if="card.last_scan"
              >{{card.last_scan.created_for}} J</b-badge>
            <b-badge pill variant="warning" v-if="!card.last_scan">{{displayDelay(card.created_at)}} J</b-badge>
          </div>
          <div class="col-sm-3">
            <small>{{card.card_id}}</small>
          </div>
          <div class="col-sm-2" v-if="card.last_workstation.name == 'Commandé'">
            <b-badge>{{card.supplier.supplier.substring(0,3)}} </b-badge>
          </div>
          <div class="col-sm-2">
            <b-badge variant="danger" v-if="card.fifo && card.fifo.length">
              FIFO
              <!-- <b-badge pill variant="dark">{{displayDelay(card.fifo[0].andon_scan.created_at)}} J</b-badge> -->
            </b-badge>
            <b-badge variant="danger" v-if="card.unseen_card && card.unseen_card.length > 0">
              Retard {{displayDate(card.unseen_card[0].next_step_estimated_at)}}
              <!-- <b-badge pill variant="dark">{{displayDelay(card.fifo[0].andon_scan.created_at)}} J</b-badge> -->
            </b-badge>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
<script>

import server from '../../../api/server.vue'
import {Steps} from '../../../core/services/steps.js'
import moment from 'moment'

export default {
  name: 'HippoCardList',
  props: ['items'],
  data() {
    return {
      stepList: Steps
    };
  },
  methods: {
    displayDelay (since) {
      var now = moment()
      return now.diff(moment(since), 'days');
    }
  }
};
</script>

<style scoped>
  .list-group-item {
    padding: 5px 30px 5px 30px;
  }
  #hyppo-card-list {
    height: 250px;
    overflow-y: auto;
  }
  #hyppo-card-list .row {
    width: 250px;
    /*padding: 5px;*/
  }
  .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4 {
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/andon/detailed/HippoCardList.vue